@import '../../theme/colors';

.successAnnouncement {
  background-color: #04844b;
  border-radius: 2px;
  color: white;
  font-size: 14px;
  letter-spacing: -0.1px;
  padding: 0 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  height: 50px;

  svg {
    margin-right: 20px;
  }
}

.priorityTwoSuccess {
  background-color: $veryLightGreen;
  border-radius: 2px;
  border: solid 1px $kermitGreen;
  color: $neutral-600;
  font-size: 12px;
  font-weight: 500;
  padding: 0 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  height: 35px;

  svg {
    margin-right: 20px;
    font-size: 18px;
    path {
      fill: $jungleGreen;
    }
  }
}

.priorityTwoFailure {
  background-color: $pale;
  border-radius: 2px;
  border: solid 1px $paleSalmon;
  color: $neutral-600;
  font-size: 12px;
  font-weight: 500;
  padding: 0 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  height: 35px;

  svg {
    margin-right: 20px;
    font-size: 18px;
    path {
      fill: $rustRed;
    }
  }
}

.failureAnnouncement {
  @extend .successAnnouncement;
  background-color: #c92100;
}
